import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface UiStore {
  sideBarOpen: boolean;
  setSideBarOpen(sideBarOpen: boolean): void;
}

export const useUiStore = create<UiStore>()(
  persist(
    (set) => ({
      sideBarOpen: false,
      setSideBarOpen: (sideBarOpen: boolean) => {
        set(() => ({ sideBarOpen }));
      },
    }),
    {
      name: "useUiStore",
    },
  ),
);
